<div
  class="tile-header"
  *ngIf="heading"
>
  <mable-heading
    [heading]="headingType"
    [icon]="icon"
    [iconColor]="iconColor"
    [class]="'text-center'"
    >{{ heading }}</mable-heading
  >
</div>

<div class="tile-content">
  <div class="tile-content-body">
    <ng-content select=".content"></ng-content>
  </div>
</div>
